export enum ELevelUser {
  USUARIO_LOJA = 3,
  MANUTENCAO_LOJA = 4,
  MANUTENCAO_REGIONAL = 5,
  GERENCIA_MANUTENCAO_REGIONAIS = 6,
  GESTAO = 7,
  ADMIN = 8,
}

export type TRegionais = {
  id: number,
  idGerencia: number,
  nome: string,
  descricao: string,
  ativo: number
}
export type TLojas = {
  id: number,
  idCoordenacao: number,
  idRegional: 2,
  numero: string,
  importanciaSegurada: number,
  nome: string,
  endereco: string,
  ativo: number
}

export type TLojaByID = {
  id: number;
  idRegional: number;
  idCoordenacao: number;
  idSeguradora: number;
  numero: string;
  nome: string;
  endereco: string;
  uf: string;
  arquivoPlanta: string;
  ativo: number;
};

export type TDivisao = {
  ativo: number,
  descricao: string,
  id: number,
  idGerencia: number,
  nome: string
}